import React from "react";
import MonthAndBranchesModal from "../../../components/templates/MonthAndBranchesModal";
import { useIntl } from "react-intl";
import moment from "moment";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";

const SendDiariesModal = ({
  branchId,
  hideSendDiaries,
  sendDiariesVisible,
  branchName,
  onSendDiaries,
  sendLoading,
}) => {
  const intl = useIntl();

  const AdditionalItems = () => (
    <>
      <CheckBoxItem
        name={"exclude_presense_reporting_clients"}
        category="employee"
        showLabel
      />
    </>
  );

  return (
    <MonthAndBranchesModal
      onHide={hideSendDiaries}
      visible={sendDiariesVisible}
      title={`${intl.formatMessage({
        id: "app.employees.send_diaries_for_branch",
      })}${branchName}`}
      btnText={intl.formatMessage({
        id: "app.actions.send",
      })}
      branchId={branchId}
      initialValues={{
        month: moment(),
        exclude_presense_reporting_clients: true,
      }}
      onSubmit={onSendDiaries}
      loading={sendLoading}
      single={true}
      additionaItems={<AdditionalItems />}
    />
  );
};

export default SendDiariesModal;
